import { defineStore } from 'pinia'

export const useDashboardStore = defineStore('dashboard', {
    state: () => ({
        data: []
    }),
    actions: {
        setData(newData) {
            this.data = newData;
        }
    },
    getters: {
    }
})